import { IDocumentActionProps } from "./DocumentTableInterfaces";
import DeleteAction from "./Actions/DeleteAction";
import EditAction from "./Actions/EditAction";
import HideAction from "./Actions/HideAction";
import ManageAction from "./Actions/ManageAction";

export default function DocumentAction({
  row,
  isAdvancedUser,
}: IDocumentActionProps) {
  const hide: boolean = process.env.REACT_APP_HIDE === "true";
  const isDeleteHidden: boolean = process.env.REACT_APP_HIDE_DELETE === "true";

  return (
    <div className="actions">
      <EditAction document={row} isAdvancedUser={isAdvancedUser} />
      {!isDeleteHidden && (
        <DeleteAction document={row} isAdvancedUser={isAdvancedUser} />
      )}
      {isAdvancedUser && (
        <HideAction document={row} isAdvancedUser={isAdvancedUser} />
      )}
      {isAdvancedUser && (
        <ManageAction document={row} isAdvancedUser={isAdvancedUser} />
      )}
    </div>
  );
}
